import React from 'react';
import AnimatedNewsBlock from '../components/AnimatedNewsBlock';
import NewsSectionLink from '../components/NewsSectionLink';
import '../styles/Subsections.css';


import viktoriyaLogo from '../img/viktoriyaLogo.png';
import agrobiznesLogo from '../img/agrobiznesLogo.png';
import yuksaLogo from '../img/yuksaLogo.png';
import ingulecLogo from '../img/ingulecLogo.png';

import metalistLogo from '../img/metalistLogo.png';
import nyvaLogo from '../img/nyvaLogo.png';
import fenixMariupolLogo from '../img/fenixMariupolLogo.png';
import probiyLogo from '../img/probiyLogo.jpeg'; 
import prykarpattiaLogo from '../img/prykarpattiaLogo.png';
import chernihivLogo from '../img/chernihivLogo.png';
import oleksandriyaLogo from '../img/oleksandriyaLogo.png';
import poltavaLogo from '../img/poltavaLogo.png';
import lokomotivLogo from '../img/lokomotivLogo.png'; 
import kulykivBilkaLogo from '../img/kulykivBilkaLogo.png';

export const firstLeagueClubs = [
  { name: 'Олександрія', image: oleksandriyaLogo, link: '/football-ukraine/oleksandriya' }, 
  { name: 'Полтава', image: poltavaLogo, link: '/football-ukraine/poltava' }, 
  { name: 'Агробізнес', image: agrobiznesLogo, link: '/football-ukraine/agrobiznes' },
  { name: 'Інгулець', image: ingulecLogo, link: '/football-ukraine/ingulec' },
  { name: 'Прикарпаття', image: prykarpattiaLogo, link: '/football-ukraine/prykarpattia' },
  { name: 'Металіст', image: metalistLogo, link: '/football-ukraine/metalist' },
  { name: 'Пробій', image: probiyLogo, link: '/football-ukraine/probiy' },
  { name: 'Фенікс-Маріуполь', image: fenixMariupolLogo, link: '/football-ukraine/fenix-mariupol' },
  { name: 'Вікторія', image: viktoriyaLogo, link: '/football-ukraine/viktoriya'},
  { name: 'ЮКСА', image: yuksaLogo, link: '/football-ukraine/yuksa' },
  { name: 'Нива', image: nyvaLogo, link: '/football-ukraine/nyva' },
  { name: 'Чернігів', image: chernihivLogo, link: '/football-ukraine/chernihiv' },
  { name: 'Куликів-Білка', image: kulykivBilkaLogo, link: '/football-ukraine/kulykiv-bilka'},
  { name: 'Локомотив', image: lokomotivLogo, link: '/football-ukraine/lokomotiv' },
];

const FirstLeagueClubs = () => {
  return (
    <AnimatedNewsBlock currentPage="first-league">
      <div className="subsections-container">
        {firstLeagueClubs.map((club) => (
          <NewsSectionLink
            to={club.link}
            section={club.name}
            key={club.name}
            className="subsection-item subsection-item-small"
          >
            <img
              src={club.image}
              alt={club.name}
              className="club-logo-small"
            />
            <span className="subsection-title">{club.name}</span>
          </NewsSectionLink>
        ))}
      </div>
    </AnimatedNewsBlock>
  );
};

export default FirstLeagueClubs;
